import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Badge, IconButton, Tooltip, useTheme } from '@mui/material'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import { useActionLogs } from '../../store/actionLogsContext'
import { canUserAccessActionHistory } from '../../pages/Statistics/statistics-report-type'
import { formatHistoryCountDisplay } from '../../utils/format-history-count'

function readStoredUser() {
  try {
    const raw = localStorage.getItem('adams_user')
    return raw ? JSON.parse(raw)?.init?.user ?? null : null
  } catch {
    return null
  }
}

/**
 * Header bell with unread count; opens the Notification Center on the map page.
 * @param {{ isDisabled?: boolean }} props
 */
export function NotificationBellButton({ isDisabled = false }) {
  const { _ } = useLingui()
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const { count } = useActionLogs()
  const user = useMemo(() => location.state?.init?.user ?? readStoredUser(), [location.state?.init?.user])

  if (!canUserAccessActionHistory(user)) return null

  return (
    <Tooltip title={_(msg`Notifications`)}>
      <span>
        <IconButton
          disabled={isDisabled}
          aria-label={_(msg`Notifications`)}
          onClick={() => navigate('/home', { state: { ...(location.state || {}), isHistoryOpen: true } })}
          sx={{ color: theme.palette.common.white }}
        >
          <Badge color="error" badgeContent={count > 0 ? formatHistoryCountDisplay(count) : 0} max={Number.MAX_SAFE_INTEGER}>
            <NotificationsNoneOutlinedIcon />
          </Badge>
        </IconButton>
      </span>
    </Tooltip>
  )
}
